export default __webpack_public_path__ + "static/media/Rounding_S2.a0ecda08.png";